/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '@ng-falcon/dialog/dialog.module';
import { LinkModule } from '@ng-falcon/navigation/link/link.module';
import { NgfControlGroupComponent } from './ngf-control-group/ngf-control-group.component';
import { IsAnyRequiredPipe } from './ngf-control/is-any-required.pipe';
import { NgfControlErrorComponent } from './ngf-control/ngf-control-error/ngf-control-error.component';
import { NgfControlHasErrorDirective } from './ngf-control/ngf-control-error/ngf-control-has-error.directive';
import { NgfControlHintComponent } from './ngf-control/ngf-control-hint/ngf-control-hint.component';
import { NgfControlLabelContainerComponent } from './ngf-control/ngf-control-label-container/ngf-control-label-container.component';
import { NgfControlMiscComponent } from './ngf-control/ngf-control-misc/ngf-control-misc.component';
import { NgfControlComponent } from './ngf-control/ngf-control.component';
import { NgfFormBtnCancelDirective } from './ngf-form-btn-cancel.directive';
import { NgfFormBtnSubmitDirective } from './ngf-form-btn-submit.directive';
import { NgfFormErrorsCounterComponent } from './ngf-form-errors-counter/ngf-form-errors-counter.component';
import { NgfFormDirective } from './ngf-form.directive';

@NgModule({
  declarations: [
    IsAnyRequiredPipe,
    NgfControlComponent,
    NgfControlErrorComponent,
    NgfControlGroupComponent,
    NgfControlHintComponent,
    NgfControlHasErrorDirective,
    NgfControlLabelContainerComponent,
    NgfControlMiscComponent,
    NgfFormBtnCancelDirective,
    NgfFormBtnSubmitDirective,
    NgfFormDirective,
    NgfFormErrorsCounterComponent,
  ],
  imports: [
    CommonModule,
    DialogModule,
    LinkModule,
  ],
  exports: [
    NgfControlComponent,
    NgfControlErrorComponent,
    NgfControlGroupComponent,
    NgfControlHintComponent,
    NgfControlHasErrorDirective,
    NgfControlMiscComponent,
    NgfFormBtnCancelDirective,
    NgfFormBtnSubmitDirective,
    NgfFormDirective,
    NgfFormErrorsCounterComponent,
    NgfControlLabelContainerComponent,
  ]
})
export class NgfFormModule {}
